<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

	<v-layout py-3>
   		<v-flex xs12 sm10 offset-sm1>
   			<v-card>
	   			<v-card-title>
            
            <v-text-field v-model="filter.id" label="Production ID" class="mr-3"></v-text-field>

            <autocomplete v-model="filter.status" :items="statuses" label="Status" />
            
            <v-autocomplete :loading="itemCodeLoading" v-model="filter.item_id" :search-input.sync="itemCodeSearch" :items="products" item-text="item_code" item-value="id" label="Search Item Code" hide-no-data>
              <template slot="item" slot-scope="data">
                <v-list-tile-content>
                  <v-list-tile-title v-text="data.item.item_code"></v-list-tile-title>
                  <v-list-tile-sub-title class="caption" v-text="data.item.category_name"></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </v-autocomplete>

            <search-btn @click="filterData" />

            <v-spacer></v-spacer>
              <v-btn v-if="hasCreateAccess" to="/production" round color="primary" dark small class="ml-4">Add New</v-btn>

			    </v-card-title>
	   			<v-data-table
				    :headers="headers"
				    :loading="processing"
				    :items="items"
				    item-key="id"
				    hide-actions
            disable-initial-sort
				  >
				  	<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
				    <template slot="headerCell" slot-scope="props">
				      <v-tooltip bottom>
				        <span slot="activator">
				          {{ props.header.text }}
				        </span>
				        <span>
				          {{ props.header.text }}
				        </span>
				      </v-tooltip>
				    </template>
				    <template slot="items" slot-scope="props">
              <tr is="production-list-item" :item="props.item" @confirm="confirmApproveItem" @cancel="confirmCancelItem"></tr>
				    </template>
				    <template slot="no-data" v-if="!processing && !items.length">
				      <v-alert :value="true" color="error" icon="warning">
				        Sorry, nothing to display here :(
				      </v-alert>
				    </template>
				  </v-data-table>

          <v-pagination @loadPage="loadPage" />

			</v-card>
   		</v-flex>

      <action-dialog action="approve" :status="approveDialog" @close="closeApproveDialog" @success="approveProduction" />
      <action-dialog action="cancel" :status="cancelDialog" @close="closeCancelDialog" @success="cancelProduction" />

   	</v-layout>
    
  </v-flex>
</template>

<script>

  import ProductionListItem from './ProductionListItem'

  export default {
    name: 'ProductionList',
    data () {
      return {
      	title: "Production List",
      	processing: false,
      	items: [],
        headers: [
          { text: 'ID', value: 'id'},
          { text: 'Product Name', value: 'product_name'},
          { text: 'Product Code', value: 'product_code'},
          { text: 'Production Date', value: 'date'},
          { text: 'Factory', value: 'factory_name'},
          { text: 'Status', value: 'status', sortable: false},
          { text: 'Actions', value: 'id', sortable: false }
        ],
        approvingItem: null,
        approveDialog: false,
        cancellingItem: null,
        cancelDialog: false,
        filter: {
          id: "",
          item_id: "",
          status: ""
        },
        products: [],
        defaultProducts: [
          {
            id: "",
            item_code: "All",
            category_name: ""
          }
        ],
        statuses: [
          {
            id: "",
            title: "All"
          }
        ],
        itemCodeLoading: false,
        itemCodeSearch: ""
      }
    },
    created () {
      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Production',
	          disabled: true
	        },
	        {
	          text: 'List',
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Production')
    },
    methods: {

      loadPage () {

        let api_path = this.config.apis.getProductions.replace(":page", this.currentPage).replace(":perPage", this.paginationOptions.rowsPerPage)
          
        let filterArray = []

        for (const [key, val] of Object.entries(this.filter)) {
          filterArray.push(`${key}=${val}`)
        }

        api_path += '?' + filterArray.join('&')

        this.processing = true
        this.axios.get(api_path)
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
            	this.items = response.data.data.items
              this.$store.commit('setItemsCount', response.data.data.total)
            }
            else{
            	this.items = []
              this.$store.commit('setItemsCount', 0)
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      searchItemsByCode () {
        let api_path = `${this.config.apis.searchItems}?item_code=${this.itemCodeSearch}`
        this.itemCodeLoading = true
        this.axios.get(api_path)
        .then((response) => {
            this.itemCodeLoading = false
            if (this.isSuccessResponse(response)) {
              this.products = response.data.data
            }
        })
        .catch((error) => {
            this.itemCodeLoading = false
        })
      },

      confirmApproveItem (item) {
        this.approvingItem = item
        this.approveDialog = true
      },

      confirmCancelItem (item) {
        this.cancellingItem = item
        this.cancelDialog = true
      },

      closeApproveDialog () {
        this.approvingItem = null
        this.approveDialog = false
      },

      closeCancelDialog () {
        this.cancellingItem = null
        this.cancelDialog = false
      },

      approveProduction () {
        
        if (!this.approvingItem) return

        this.processing = true
        this.axios.put(this.config.apis.approveProduction.replace(":id", this.approvingItem.id))
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              this.approvingItem.status = this.config.productionStatus.approved

              this.notifySuccess('updateSuccess')
              this.closeApproveDialog()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
            this.closeApproveDialog()
          })

      },

      cancelProduction () {
        
        if (!this.cancellingItem) return

        this.processing = true
        this.axios.put(this.config.apis.cancelProduction.replace(":id", this.cancellingItem.id))
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              this.cancellingItem.status = this.config.productionStatus.cancelled

              this.notifySuccess('updateSuccess')
              this.closeCancelDialog()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
            this.closeCancelDialog()
          })

      }

    },
    mounted () {

      for (const [key, val] of Object.entries(this.config.productionStatus)) {
          this.statuses.push({id: val, title: key})
      }

    },

    computed: {

    },

    watch: {
      
      itemCodeSearch (val, oldVal) {
        if (val && val != oldVal) {
          this.searchItemsByCode()
        }
      }

    },
    
    components: {
      'production-list-item': ProductionListItem
    }

  }
</script>
